import Vue from 'vue'
import VueRouter from 'vue-router'
import RegistrationMain from '../views/RegistrationMain.vue'
import RegistrationCompleted from '../views/RegistrationCompleted.vue'

Vue.use(VueRouter)

const AppRouter = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/Abschluss/:status',
        component: RegistrationCompleted,
        props: true
      }, { 
        path: '/:clubNumber',
        component: RegistrationMain
      }
    ]
})

AppRouter.beforeEach((to, from, next) => {
    document.title = 'Vereinsanmeldung'
    next()
})

export default AppRouter